import React, {useRef} from 'react';

interface VisiblePasswordProps {
    id: string;
}

export default function VisiblePassword({id}: VisiblePasswordProps) {

    let eyeControl = useRef<HTMLElement>(null);
    let editControl = useRef<HTMLInputElement>(null);

    function clickEye(): void {

        if(editControl.current?.getAttribute("type") == "text"){
            editControl.current?.setAttribute('type', 'password');
            eyeControl.current?.classList.add( "fa-eye-slash" );
            eyeControl.current?.classList.remove( "fa-eye" );
          }
          else {
            editControl.current?.setAttribute('type', 'text');
            eyeControl.current?.classList.add( "fa-eye" );
            eyeControl.current?.classList.remove( "fa-eye-slash" );
          }
    }

    return (
        <div className="wts-pass-show">
            <input
                ref={editControl}
                type="password"
                id={id}
                name="password"
                className="form-control"
            />

            <span className="wts-pass-text">
                <i 
                    ref={eyeControl} 
                    onClick={clickEye}
                    className="fa fa-eye-slash" 
                    aria-hidden="true"
                />
            </span>
        </div>
    )
}